import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';
import mixpanel from 'mixpanel-browser';
import { isLocalHost } from './helpers/environmentHelper';

if (!isLocalHost()) {
  Sentry.init({
    dsn: 'https://da84e6c800f9dd217732a3fd032af57d@o4508201207791616.ingest.de.sentry.io/4508201560637520',
    integrations: [],
  });

  mixpanel.init('75734a12aea7e6a77708f9ddc6582388', {
    api_host: 'https://api-eu.mixpanel.com',
    debug: true,
    track_pageview: true,
    persistence: 'localStorage',
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Disabled strict mode since it causes double calling the auth apis on page load.
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
